import React, { useEffect, useState } from 'react';
import { getProfile } from '../../../services/profileService';

interface User {
  name: string;
  role: string;
  position?: string;
  email: string;
  phone: string;
  shift: string;
  profile_image?: string;
}

const UserInfo: React.FC = () => {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProfile = async () => {
      const data = await getProfile();
      setUser(data);
      setLoading(false);
    };
    fetchProfile();
  }, []);

  if (loading) return <div className="bg-white p-8">Loading...</div>;
  if (!user) return <div className="bg-white p-8">Failed to load profile.</div>;

  const displayTitle = user.position || user.role;

  return (
    <div className="bg-white p-8">
      <div className="flex items-center gap-4 mb-8">
        {user.profile_image ? (
          <img src={user.profile_image} alt={user.name} className="w-20 h-20 rounded-full object-cover" />
        ) : (
          <div className="w-20 h-20 rounded-full bg-blue-600 flex items-center justify-center text-2xl font-bold text-white flex-shrink-0">
            {user.name?.charAt(0).toUpperCase()}
          </div>
        )}
        <div>
          <h2 className="text-2xl font-semibold">{user.name}</h2>
          <p className="text-gray-500">{displayTitle}</p>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-6">
        <div>
          <label className="text-gray-500 text-sm">Full Name</label>
          <div className="bg-gray-100 p-2 rounded-md">{user.name}</div>
        </div>
        <div>
          <label className="text-gray-500 text-sm">Role</label>
          <div className="bg-gray-100 p-2 rounded-md">{user.role}</div>
        </div>
        <div>
          <label className="text-gray-500 text-sm">Mail Id</label>
          <div className="bg-gray-100 p-2 rounded-md">{user.email}</div>
        </div>
        <div>
          <label className="text-gray-500 text-sm">Phone Number</label>
          <div className="bg-gray-100 p-2 rounded-md">{user.phone}</div>
        </div>
        <div>
          <label className="text-gray-500 text-sm">Shift</label>
          <div className="bg-gray-100 p-2 rounded-md">{user.shift}</div>
        </div>
      </div>
    </div>
  );
};

export default UserInfo;
